import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6cbf7528")

_pushScopeId("data-v-6cbf7528")
const _hoisted_1 = {
  key: 0,
  class: "activity-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_one_price = _resolveComponent("one-price")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.activity.length>0)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", null, [
            (_ctx.activity.length)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: require('@/assets/image/gift.png')
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activity, (item) => {
            return (_openBlock(), _createBlock("p", { key: item }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_one_price, {
      total: _ctx.total,
      coupon: _ctx.coupon,
      before: _ctx.before
    }, null, 8, ["total", "coupon", "before"])
  ]))
})